import {
  DomainName,
  IDictInputControl,
  StringDomain,
  TControlName,
} from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  DictionaryInputFormControlViewModel,
  FormControlViewModelType,
  LocalizedProps,
} from '../../view-model/FormControlViewModel';
import { FormSourceType } from '../../view-model/FormSource';
import { FormViewModel } from '../../view-model/FormViewModel';

import {
  buildCommonDictionaryButtonModel,
  controlDomain,
  getControlValueHistory,
  getValueFromArgsOrConfig,
} from './helpers';

const buildDictInputControl = async (
  viewModel: FormViewModel,
  item: IDictInputControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  domains: Array<{ name: TControlName; domain: DomainName }>
): Promise<DictionaryInputFormControlViewModel> => {
  const domain = (await controlDomain(
    item,
    viewModel.source,
    domains
  )) as StringDomain;

  return {
    ...buildCommonDictionaryButtonModel(item, viewModel.source),
    canClearOnReadOnly: item.canClearOnReadOnly,
    multiSelect: item.multiSelect || false,
    outParams: item.outParams || {},

    columns: item.columns,
    disabled: item.disabled,
    enableButtonOnReadOnly: viewModel.source.type !== FormSourceType.REVIEW,
    hasHistory: true,
    hasValue: true,
    history: getControlValueHistory(viewModel.source, item.name),
    invalid: item.invalid,
    errorMessage: item.errorMessage,
    labelWidth: item.labelWidth,
    lengthInBytes: domain.lengthInBytes,
    maxLength: domain.length,
    name: item.name,
    noLabel: item.noLabel,
    readonly: item.readonly,
    required: item.required,
    storeValue: item.storeValue,
    trim:
      (item.trim ??
      ((await controlDomain(item, viewModel.source, domains)) as StringDomain)
        .nonBlank)
        ? ['left', 'right']
        : undefined,
    type: FormControlViewModelType.DICTIONARY_INPUT,
    updater: item.updater,
    value: getValueFromArgsOrConfig(item, args, viewModel.source, ''),
    visible: item.visible,
    ...localizedProps,
  };
};

export default buildDictInputControl;
